import { Divider as MuiDivider, DividerProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { DividerProps };

export const Divider: React.ComponentType<DividerProps> = styled(MuiDivider)<DividerProps>(
  () => ({}),
);
